export default "__VITE_ASSET__eI$f4RMq__"